module.exports = __webpack_public_path__ + "img/3b6e4a1.png";